/**
 * Landing media registry — the real product screenshots and demo videos captured
 * from production by `scripts/landing-media/capture.mjs` (see
 * `public/landing/media-manifest.json`). Files live under `public/landing/`.
 *
 * Every screenshot ships as `<id>.webp` with a `<id>.jpg` fallback at
 * SHOT_WIDTH x SHOT_HEIGHT; every video as `<id>.mp4` + `<id>.webm` with a
 * `<id>-poster.webp` at VIDEO_WIDTH x VIDEO_HEIGHT. The intrinsic sizes are
 * always rendered as width/height attributes so media never causes layout shift.
 */

export const SHOT_WIDTH = 1600;
export const SHOT_HEIGHT = 1000;
export const VIDEO_WIDTH = 1280;
export const VIDEO_HEIGHT = 720;

export const SHOT_IDS = [
  'today',
  'autopilot',
  'composer',
  'ai-team',
  'crm',
  'email-templates',
  'outreach-consent',
  'analytics',
  'reel-studio',
] as const;
export type ShotId = (typeof SHOT_IDS)[number];

export const VIDEO_IDS = ['autopilot', 'composer-calendar', 'ai-team', 'crm-email', 'reel-studio'] as const;
export type VideoId = (typeof VIDEO_IDS)[number];

export const shotSrc = (id: ShotId, ext: 'webp' | 'jpg') => `/landing/shots/${id}.${ext}`;
export const videoSrc = (id: VideoId, ext: 'mp4' | 'webm') => `/landing/video/${id}.${ext}`;
export const videoPoster = (id: VideoId) => `/landing/video/${id}-poster.webp`;

/** Public site origin used for canonical / Open Graph URLs. */
export const SITE_ORIGIN = 'https://www.karexia.com';
export const OG_IMAGE_PATH = '/landing/og.png';
